import { render, staticRenderFns } from "./CategoriesGroupEdit.vue?vue&type=template&id=0897d57a&scoped=true&"
import script from "./CategoriesGroupEdit.vue?vue&type=script&lang=js&"
export * from "./CategoriesGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesGroupEdit.vue?vue&type=style&index=0&id=0897d57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897d57a",
  null
  
)

export default component.exports